import { CheckIcon, type ToastOptions, type ToastParams, useToast as useToastUI } from "@povio/ui";
import { useCallback } from "react";

export const useToast = () => {
  const { successToast, errorToast, warningToast, neutralToast } = useToastUI();

  return {
    successToast: useCallback(
      (params: ToastParams, options: ToastOptions = {}) =>
        successToast({ ...params, icon: CheckIcon }, { autoClose: 2000, closeOnClick: true, ...options }),
      [successToast],
    ),
    errorToast: useCallback(
      (params: ToastParams, options: ToastOptions = {}) =>
        errorToast({ ...params }, { autoClose: 5000, closeOnClick: true, ...options }),
      [errorToast],
    ),
    warningToast: useCallback(
      (params: ToastParams, options: ToastOptions = {}) =>
        warningToast({ ...params }, { autoClose: 5000, closeOnClick: true, ...options }),
      [warningToast],
    ),
    neutralToast: useCallback(
      (params: ToastParams, options: ToastOptions = {}) =>
        neutralToast({ ...params }, { autoClose: false, closeOnClick: true, ...options }),
      [neutralToast],
    ),
  };
};
